module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "loading_pool"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading_box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/loading.png",
      "alt": "安徽继续教育网"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "loading_text"
  }, [_vm._v("加载中...")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3605c660"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loading.vue
// module id = 235
// module chunks = 86